import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder } from '@angular/forms';
import isLoggedIn from '@line/liff/dist/lib/auth/isLoggedIn';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-cal-conditions',
  templateUrl: './cal-conditions.component.html',
  styleUrls: ['./cal-conditions.component.css']
})
export class CalConditionsComponent implements OnInit {

  display_pdf: boolean = false;
  admin_data:any;
  data_con! : FormGroup;
  file!: string;
  data_file: string[] = [];
  filedata!: string

  data_date = [] as any;
  date_select: any;
  data_all: any;
  data_show: any;
  date_now = new DatePipe('en-US').transform(new Date(), 'MM-dd-yyyy')
  pdfSrc: any;

  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    document.getElementById('calconditions')!.classList.toggle("active");

    this.getDataAll();
    this.date_now = this.dateThai(this.date_now);
    this.data_con = this.formBuilder.group({
      interest: '',
      date_declare: '',
      date_used: '',
      pdf_file: '',
      user_id: parseInt(this.admin_data.id),
      status: "Enable"
    })
  }
  ngOnDestroy(){
    document.getElementById('calconditions')!.classList.remove("active");
  }

  async getDataAll() {
    var datas: any = [];
    this.data_date = [];
    let dates = {
      th:'',
      default:''
    }
    await this.services.get('m_calconditions').then(async (res: any) => {
      res.forEach((data: any) => {
        if (data.status == 'Enable') {
          dates = {
            th:'',
            default:''
          }
          data.date_declare_th = this.dateThai(data.date_declare)
          data.date_used_th = this.dateThai(data.date_used)
          datas.push(data);
          dates.th = data.date_declare_th
          dates.default = data.date_declare
          this.data_date.push(dates)
        }
      });
      this.getData(datas, await this.data_date[0].default);
    });
  }

  getData(data: any, date: any) {
    this.data_all = data;
    this.date_select = date;
    this.select_data();
  }

  select_data(ev?: any) {
    this.data_all.forEach((data: any) => {
      if (data.date_declare == this.date_select) {
        this.data_show = data;
      }
    });
  }

  onFileSelect(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.file = event.target.files[0];
      this.data_file.push(event.target.files[0]);
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.filedata = reader.result as string;
        this.data_con.patchValue({
          fileSource: reader.result
        });
      };
    }
  }

  onClick() {
    const formData = new FormData();
    formData.append('pdf_file', this.data_file[0]);
    formData.append('interest', this.data_con.get('interest')!.value);
    formData.append('date_declare', this.data_con.get('date_declare')!.value);
    formData.append('date_used', this.data_con.get('date_used')!.value);
    formData.append('user_id', this.data_con.get('user_id')!.value);
    formData.append('status', this.data_con.get('status')!.value);

    this.services.uploadFile('m_calconditions', formData).then((res: any) => {
      window.scroll(0, 0);
      this.getDataAll();
      this.file = ''
      this.data_file= []
      this.filedata= ''
      this.data_con = this.formBuilder.group({
        interest: '',
        date_declare: '',
        date_used: '',
        pdf_file: '',
        user_id: parseInt(this.admin_data.id),
        status: "Enable"
      })
    });
  }
  onClose(){
    this.data_con = this.formBuilder.group({
      interest: '',
      date_declare: '',
      date_used: '',
      pdf_file: '',
      user_id: parseInt(this.admin_data.id),
      status: "Enable"
    })
  }

  onClickView(file_name:any){
    this.display_pdf = true;
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/"+file_name;
  }
  onClickDownload(file_name:any, date_declare:any){
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/"+file_name;
    FileSaver.saveAs(this.pdfSrc, 'MLRประกาศ ณ วันที่'+date_declare);
  }
  onClickBack(){
    this.display_pdf = false;
    window.scroll(0, 0);
  }
  dateThai(date: any) {
    var newDate = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return newDate;
  }

  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
}
